import React, { useEffect, useState } from "react";
import { withAuthenticationRequired } from "../context/AuthContext";
import uuid from "react-uuid";
import Loading from "../components/Loading";
import { MenuItem, Select, TextField, Button, Input } from "@mui/material";
import { categorias } from "../utils/constants";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { showErrorMessage } from "../redux/appSlice";
import { useDispatch } from "react-redux";
import GoogleMapsSearch from "../components/GoogleMapsSearch";
import ImageUploadField from "../components/ImageUploadField";
import ReorderableList from "../components/ReorderableList";
import { useRequestHandler } from "../utils/useRequestHandler";
import Servicios from "../services";

export const Conjuntos = () => {
  const [conjuntos, setConjuntos] = useState([]);
  const [categoria, setCategoria] = useState(0);
  const [agregando, setAgregando] = useState(false);
  const [nombre, setNombre] = useState("");
  const [elenco, setElenco] = useState([]);
  const [editando, setEditando] = useState(false);
  const [idEditando, setIdEditando] = useState(0);
  const [localEnsayo, setLocalEnsayo] = useState("");
  const [localEnsayoDireccion, setLocalEnsayoDireccion] = useState("");
  const center = { lat: -34.895033, lng: -56.165009 };
  const [marker, setMarker] = useState(center);
  const [imagen, setImagen] = useState(null);
  const [imgPreviewSrc, setImgPreviewSrc] = useState("");
  const [elencoRol, setElencoRol] = useState("");
  const [elencoNombre, setElencoNombre] = useState("");
  const sendRequest = useRequestHandler();
  const [concurso, setConcurso] = useState(0);
  const [concursos, setConcursos] = useState([]);

  const refrescarGrilla = () => {
    sendRequest(Servicios.ConjuntosPorCategoria, [categoria], data => {
      setConjuntos(data?.data);
    });
  };
  const dispatch = useDispatch();

  const limpiarForm = () => {
    setNombre("");
    setCategoria(0);
    setElenco([]);
    setMarker(center);
    setImagen(null);
    setImgPreviewSrc("");
    setLocalEnsayo("");
    setLocalEnsayoDireccion("");
    setElencoNombre("");
    setElencoRol("");
  };

  useEffect(() => {
    refrescarGrilla();
  }, [categoria]);

  useEffect(() => {
    sendRequest(Servicios.ObtenerConcursos, [], data => {
      setConcursos(data?.data);
    });
    sendRequest(Servicios.ObtenerConcursoActual, [], data2 => {
      setConcurso(data2.data);

    });
  }, []);


  const eliminarConjunto = id => {
    sendRequest(Servicios.EliminarConjunto, [id], refrescarGrilla);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 10 },
    { field: "nombre", headerName: "Nombre", flex: 80 },
    { field: "categoria", headerName: "Categoria", flex: 80 },
    {
      field: "actionEdit",
      headerName: "",
      sortable: false,
      minWidth: 10,
      align: "right",
      renderCell: params => {
        const onClick = e => {
          setAgregando(true);
          setEditando(true);
          setIdEditando(params.row.id);
          sendRequest(Servicios.ObtenerConjuntoPorId, [params.row.id], data => {
            setNombre(data.data.nombre);
            setCategoria(data.data.categoriaId);
            setElenco(
              data.data.elenco?.map(x => ({ ...x, _localId: uuid() }))
            );
            setMarker({
              lat: data.data.localEnsayoLatitud,
              lng: data.data.localEnsayoLongitud
            });
            setImgPreviewSrc(data.data.imagenPath);
            setLocalEnsayo(data.data.localEnsayoNombre);
            setLocalEnsayoDireccion(data.data.localEnsayoDireccion);
          });
        };

        return <EditIcon className="action-icon" onClick={onClick} />;
      }
    },
    {
      field: "actionDelete",
      headerName: "",
      sortable: false,
      minWidth: 10,
      align: "right",
      renderCell: params => {
        const onClick = e => {
          if (window.confirm("¿Confirmás eliminar el conjunto?")) {
            eliminarConjunto(params?.row?.id);
          }
        };

        return <DeleteIcon className="action-icon" onClick={onClick} />;
      }
    }
  ];

  const handleGuardar = () => {
    const elencoParaGuardar = elenco.map(({ _localId, ...resto }) => resto);
    if (editando) {
      sendRequest(
        Servicios.ModificarConjunto,
        [
          {
            id: idEditando,
            nombre: nombre,
            categoriaId: categoria,
            elenco: elencoParaGuardar,
            elencoAnio: concurso?.anio ?? 0,
            localEnsayo: {
              nombre: localEnsayo,
              direccion: localEnsayoDireccion,
              longitud: marker.lng,
              latitud: marker.lat
            }
          },
          imagen
        ],
        () => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
        }
      );
    } else {
      sendRequest(
        Servicios.CrearConjunto,
        [
          {
            id: idEditando,
            nombre: nombre,
            categoriaId: categoria,
            elenco: elencoParaGuardar,
            elencoAnio: concurso?.anio ?? 0,
            localEnsayo: {
              nombre: localEnsayo,
              direccion: localEnsayoDireccion,
              longitud: marker.lng,
              latitud: marker.lat
            }
          },
          imagen
        ],
        () => {
          limpiarForm();
          setEditando(false);
          setAgregando(false);
          refrescarGrilla();
        }
      );
    }
  };

  return (
    <div className="card-modern">
      {!agregando ? (
        <>
          <div className="flex flex-wrap items-center justify-between gap-3 p-2">
            <div className="page-header">
              <h4 className="page-title">Listado de conjuntos</h4>
            </div>
            <div>
              <Select
                style={{ width: 200 }}
                size="small"
                placeholder="Categoría"
                value={categoria}
                onChange={e => setCategoria(e.target.value)}
              >
                <MenuItem key={0} value={0}>
                  {"Categoría..."}
                </MenuItem>
                {categorias?.map(c => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.nombre}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div>
              <Button
                variant={"contained"}
                onClick={() => {
                  setCategoria(0);
                  setAgregando(true);
                }}
              >
                Agregar
              </Button>
            </div>
          </div>
          <hr></hr>
          <div className="grid-wrapper w-full p-2">
            {conjuntos?.length > 0 ? (
              <DataGrid
                rows={conjuntos}
                columns={columns}
                paginationModel={{ page: 0, pageSize: 50 }}
                checkboxSelection={false}
              />
            ) : (
              <h5>No se encontraron resultados</h5>
            )}
          </div>
        </>
      ) : (
        <div>
          <div className="flex flex-col md:flex-row gap-4 w-auto">
            <div className="flex-1">
              <div className="flex flex-wrap items-center justify-between gap-3 p-2">
                <div className="page-header">
                  <h4 className="page-title">
                    {editando ? "Modificar conjunto" : "Nuevo conjunto"}
                  </h4>
                </div>
                <div>
                  <Select
                    style={{ width: 200 }}
                    size="small"
                    placeholder="Concurso"
                    value={concurso?.id}
                    onChange={e => setConcurso(concursos.find(x => x.id == e.target.value))}
                  >

                    {concursos?.map(c => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.nombre}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="mb-3 p-2">
                <TextField
                  className="w-full"
                  size="small"
                  label="Nombre"
                  value={nombre}
                  onChange={e => setNombre(e.target.value)}
                />
              </div>

              <div className="mb-3 p-2">
                <Select
                  className="w-full"
                  size="small"
                  placeholder="Categoría"
                  value={categoria}
                  onChange={e => setCategoria(e.target.value)}
                >
                  <MenuItem key={0} value={0}>
                    {"Categoría"}
                  </MenuItem>
                  {categorias?.map(c => (
                    <MenuItem key={c.id} value={c.id}>
                      {c.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className="p-2">
                <h6>Elenco</h6>
                <div className="draggable-item p-2">
                  <ReorderableList
                    items={elenco}
                    getItemId={item => item._localId}
                    onChange={setElenco}
                    reindexKey="posicion"
                    renderItem={(x, i, { dragHandleProps }) => (
                      <div
                        className="flex items-center gap-2 p-2 item"
                        {...dragHandleProps}
                      >
                        <b className="shrink-0 text-start">{x.clave}</b>
                        <span className="flex-1 text-start ms-2">
                          {x.descripcion}
                        </span>
                        <div className="shrink-0">
                          <DeleteIcon
                            className="action-icon"
                            onClick={() => {
                              setElenco(
                                elenco.filter(y => y._localId !== x._localId)
                              );
                            }}
                          />
                        </div>
                      </div>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-2 p-2">
                  <TextField
                    className="w-full"
                    size="small"
                    label="Rol"
                    value={elencoRol}
                    onChange={e => setElencoRol(e.target.value)}
                  ></TextField>
                  <TextField
                    className="w-full"
                    size="small"
                    label="Nombre/s"
                    value={elencoNombre}
                    onChange={e => setElencoNombre(e.target.value)}
                    multiline
                    rows={4}
                  ></TextField>
                  <div className="text-end">
                    <Button
                      variant={"outlined"}
                      onClick={() => {
                        setElenco([
                          ...elenco,
                          {
                            clave: elencoRol,
                            descripcion: elencoNombre,
                            _localId: uuid()
                          }
                        ]);
                        setElencoNombre("");
                        setElencoRol("");
                      }}
                    >
                      + Agregar
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1">
              <div className="ms-4 px-4">
                <ImageUploadField
                  value={imagen}
                  previewSrc={imgPreviewSrc}
                  onChange={(file, previewDataUrl) => {
                    setImagen(file);
                    setImgPreviewSrc(previewDataUrl);
                  }}
                  onError={message => dispatch(showErrorMessage(message))}
                />
              </div>
              <div id="map" className="w-full p-2">
                <GoogleMapsSearch
                  title="Local de ensayo"
                  texto={localEnsayo}
                  setTexto={setLocalEnsayo}
                  marker={marker}
                  setMarker={setMarker}
                ></GoogleMapsSearch>
              </div>
              <div className="mb-3 w-full p-2">
                <TextField
                  className="w-full"
                  size="small"
                  label="Dirección"
                  value={localEnsayoDireccion}
                  onChange={e => setLocalEnsayoDireccion(e.target.value)}
                ></TextField>
              </div>
            </div>
          </div>
          <hr></hr>
          <div className="flex items-center justify-center w-auto">
            <div className="flex-1 text-start">
              <Button
                variant={"outlined"}
                onClick={() => {
                  limpiarForm();
                  setEditando(false);
                  setAgregando(false);
                }}
              >
                Cancelar
              </Button>
            </div>
            <div className="flex-1 text-end">
              <Button variant={"contained"} onClick={handleGuardar}>
                Guardar
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default withAuthenticationRequired(Conjuntos, {
  onRedirecting: () => <Loading />
});
